import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';

const REASONS = [
  'Duplicate order',
  'Already paid',
  'Not payable status',
  'Data error',
  'Cancelled',
  'Other',
];

/**
 * Collects a required reason (+ optional note) before excluding a row.
 * onConfirm({ reason, note }) is called on submit.
 */
function ExcludeRowDialog({ open, row, onClose, onConfirm, submitting }) {
  const [reason, setReason] = useState('');
  const [note, setNote] = useState('');

  useEffect(() => {
    if (open) {
      setReason('');
      setNote('');
    }
  }, [open]);

  const valid = reason && reason.trim().length > 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Exclude row{row ? ` #${row.source_row_number}` : ''} from payment</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FormControl fullWidth required>
            <InputLabel>Reason</InputLabel>
            <Select value={reason} label="Reason" onChange={(e) => setReason(e.target.value)}>
              {REASONS.map((r) => (
                <MenuItem key={r} value={r}>{r}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Note (optional)"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            multiline
            rows={2}
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>Cancel</Button>
        <Button
          variant="contained"
          color="error"
          disabled={!valid || submitting}
          onClick={() => onConfirm({ reason: reason.trim(), note: note.trim() || undefined })}
        >
          Exclude
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ExcludeRowDialog;
